import { faLink } from "@fortawesome/pro-regular-svg-icons/faLink";

import "../assets/scss/components/_review.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { ReviewProps } from "../types/components/ReviewProps";
import { ReviewStars } from "./ReviewStars";

export const Review = ({ rating, timeago, text, reviewer, link }: ReviewProps) => {
	return (
		<div className="review">
			<ReviewStars score={rating} />
			<p className="review-text">{text}</p>
			<a href={link} className="view-review" target="_blank" rel="noopener noreferrer" aria-label="View Review">
				<FontAwesomeIcon icon={faLink} />
			</a>
			<span className="bottom">
				<span className="timeago">{timeago}</span>
				<span className="reviewer">{reviewer}</span>
			</span>
		</div>
	);
};

export default Review;
